// Imports
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateTimeCell from '../../../../../../shareables/foundation/front-end/components/tables/date-time-cell';
import APIButton, { APIButtonOptions } from '../../../../../../shareables/integrations/api/components/button';
import { GetGarageSalesResponse } from '../../../../../../shareables/types/api/main/website/page/type/212/garage-sales/get';


// Define the accepted props
interface Props {
	garageSale: GetGarageSalesResponse[0];
	onChange: () => void;
	pageID: number;
	displayRemoveCell: boolean;
}


// Function component
const GarageSalesRow: React.FC<Props> = ({ garageSale, onChange, pageID, displayRemoveCell }) => {
	// Build button options
	const buttonOptions: APIButtonOptions<undefined, undefined, undefined> = {
		action: 'DELETE',
		uri: `/website/${window.location.hostname}/page/id_${pageID}/type/212/garage-sale/${garageSale.id}`,
		tooltip: 'Delete this garage sale',
		warning: {
			message: 'Deleting this garage sale is permanent.',
			button: `Yes, delete this sale on “${new Date(garageSale.start).toLocaleDateString(undefined, {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
			})}”`,
		},
	};
	
	
	// Return JSX
	return (
		<tr>
			<DateTimeCell dateTime={garageSale.start} />
			
			<td className='allow-wrapping'>{garageSale.address}</td>
			
			<td className='allow-wrapping'>{garageSale.host}</td>
			
			{displayRemoveCell && (
				<td style={{ textAlign: 'center' }}>
					{garageSale.canDelete && (
						<APIButton
							options={buttonOptions}
							color='danger'
							aria-label={`Delete this sale on “${new Date(garageSale.start).toLocaleDateString(undefined, {
								month: 'short',
								day: 'numeric',
								year: 'numeric',
								hour: 'numeric',
								minute: '2-digit',
							})}”`}
							onCompletion={onChange}
							smaller
						>
							<FontAwesomeIcon icon={faTrash} />
						</APIButton>
					)}
				</td>
			)}
		</tr>
	);
};

export default GarageSalesRow;
